import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const ShelfAutocomplete = loadable(() => import('./ShelfAutocomplete'), {});
